import {utc as moment} from 'moment';

export const toUtc = (date) => moment(date).format('YYYY-MM-DD HH:mm:ss');
export const toUtcDate = (date) => moment(date).format('YYYY-MM-DD');
export const getDisplayDate = (date, options = {returnMills: false, format: 'YYYY-MM-DD kk-mm-ss'}) => {
  let {returnMills, format} = options,

    sample_time =  moment(date).valueOf(),
    sample_time_zone = moment(date)._tzm * 60000,
    local_time_zone_offset = -new Date().getTimezoneOffset() * 60000,

    display_time_mills = sample_time - sample_time_zone + local_time_zone_offset;

  if(returnMills) return display_time_mills;
  return moment(sample_time - sample_time_zone + local_time_zone_offset).format(format)
};


// WEBPACK FOOTER //
// ./src/libs/date.js